import React, { useState, useEffect, useCallback, useRef } from "react";
import {
  DescriptionOutlined,
  DifferenceOutlined,
  PersonOutlineRounded,
  SearchOutlined,
  MailOutline,
} from "@mui/icons-material";
import PersonOffOutlinedIcon from "@mui/icons-material/PersonOffOutlined";
import ClearIcon from "@mui/icons-material/Clear"; // Import Clear icon
import { appSelector } from "../../redux/selector";
import Key from "../../../clientVariables.json";
import {
  Grid,
  Avatar,
  IconButton,
  Box,
  Paper,
  List,
  ListItemButton,
  Stack,
  Tooltip,
  Typography,
  useMediaQuery,
  Toolbar,
  Divider,
  Checkbox,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Alert,
  Pagination,
  MenuItem,
  Select,
} from "@mui/material";
import InfiniteScroll from "react-infinite-scroll-component";
import { useLocation, useNavigate } from "react-router-dom";
import {
  getActiveCandidatesAction,
  resetAction,
  getMyRecruitersAction,
} from "../../redux/action";
import { userSelector } from "../../user-redux/selector";
import { myCandidatesSelector } from "../../MyCandidates/redux/selector";
import {
  clearCandidateDetailsAction,
  getCandidateDetailAction,
} from "../../MyCandidates/redux/action";
import { useDispatch, useSelector } from "react-redux";
import LoadingSkeleton from "../../loadingSkeletons/LoadingList";
import {
  selectedCandidateAction,
  updateCandidateStatusAction,
} from "../../redux/action";
import { heIL } from "@mui/x-date-pickers";
import { limit } from "../../utils/constantValues";
import { toast } from "react-toastify";
import HowToRegIcon from '@mui/icons-material/HowToReg';
import PersonRemoveIcon from '@mui/icons-material/PersonRemove';
import DeleteIcon from "@mui/icons-material/Delete";

const avatarColors = [
  "#C5CAE9",
  "#DCEDC8",
  "#FFECB3",
  "#F8BBD0",
  "#C8E6C9",
  "#FFD180",
  "#BBDEFB",
  "#FFCC80",
  "#E6EE9C",
  "#FFD180",
];
const ActiveCandidates = ({ openProfileView, onSearchEmptyChange }) => {
  const isDesktopXS = useMediaQuery(
    "(min-width: 992px) and (max-width: 1199px)"
  );
  const isDesktopSmall = useMediaQuery(
    "(min-width: 1200px) and (max-width: 1439px)"
  );
  const isDesktopMedium = useMediaQuery(
    "(min-width: 1440px) and (max-width: 1919px)"
  );
  const isDesktopLarge = useMediaQuery("(min-width: 1920px)");

  const paperStyles = {
    borderRadius: "8px",
    height: "calc(100vh - 160px)", // Adjusted to fit screen without scrolling
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
  };

  const hoverIconStyles = {
    height: isDesktopLarge
      ? "20px"
      : isDesktopMedium
        ? "18px"
        : isDesktopSmall
          ? "16px"
          : "13px",
    width: isDesktopLarge
      ? "20px"
      : isDesktopMedium
        ? "18px"
        : isDesktopSmall
          ? "16px"
          : "13px",
    color: "#616161",
    marginLeft: 1, // Gap between icons
    display: "inline-block",
  };
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const [candidates, setCandidates] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [hoveredCandidate, setHoveredCandidate] = useState(null);
  const [selectedCandidates, setSelectedCandidates] = useState([]);
  const [showInbox, setShowInbox] = useState(false);
  const [searchQuery, setSearchQuery] = useState(""); // State for search query
  const [showSearchBox, setShowSearchBox] = useState(false); // State to toggle the search box visibility
  const [activeCandidateId, setActiveCandidateId] = useState(null); // State to track selected candidate
  const [page, setPage] = useState(1);
  const [isFetching, setIsFetching] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [inactiveReason, setInactiveReason] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [checkedcustomerData, setCheckedCustomerData] = useState([]);
  const [selectedItems, setSelectedItems] = useState();
  const [selectedCandidate, setSelectedCandidate] = useState([]);
  const [recruiterDetails, setRecruiterDetails] = useState([]);
  const [allRecruiters, setAllRecruiters] = useState([])
  const [allocatedCandidates, setAllocatedCandidates] = useState([])
  const [recruiterMap, setRecruiterMap] = useState({});
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [candidateToDelete, setCandidateToDelete] = useState(null);
  const [currentPage, setCurrentPage] = useState(1)
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const [checkedCandidates, setCheckedCandidates] = useState([])
  const [isDeleting, setIsDeleting] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);

  const startIndex = ((currentPage - 1) * rowsPerPage)
  const endIndex = (startIndex + rowsPerPage)

  const { user } = useSelector(userSelector);
  const { activeCandidates, total_candidates, candidateDetails, tabView } =
    useSelector(myCandidatesSelector);

  const { myRecruiters, activeCandLoading } = useSelector(appSelector);

  useEffect(() => {

    if (myRecruiters?.length > 0) {
      const recruiterIds = myRecruiters.map(rec => rec.recruiter_id);
      setAllRecruiters(recruiterIds);
    }
  }, [myRecruiters]);

  useEffect(() => {

  }, [allRecruiters]);

  useEffect(() => {

    if (activeCandidates?.length > 0) {
      const candidateIds = activeCandidates.map(recruiter => recruiter.r_id);
      setAllocatedCandidates(candidateIds);
    }
  }, [activeCandidates]);

  useEffect(() => {

  }, [allocatedCandidates]);



  useEffect(() => {

    const map = {};
    myRecruiters?.forEach(recruiter => {
      map[String(recruiter.recruiter_id)] = recruiter.recruiter_name;

    });
    setRecruiterMap(map);
  }, [myRecruiters]);

  useEffect(() => {

  }, [recruiterMap]);

  const getRecruiterName = useCallback((r_id) => {
    if (!r_id || Object.keys(recruiterMap).length === 0) {
      return "Not allocated";
    }

    let ids = [];
    if (Array.isArray(r_id)) {
      ids = r_id.map(id => String(id).trim()).filter(Boolean);
    } else if (typeof r_id === 'number') {
      ids = [String(r_id).trim()];
    } else if (typeof r_id === 'string') {
      ids = r_id.split(',').map(id => id.trim()).filter(Boolean);
    } else {
      return "Not allocated";
    }

    // Only show recruiter names that exist in the map
    const names = ids.map(id => recruiterMap[id]).filter(Boolean);
    if (names.length === 0) return "Not allocated";
    return names.join(", ");
  }, [recruiterMap]); // Add recruiterMap as a dependency


  const isEffectRun = useRef(false); // Tracks if the effect has already run
  const hasLoadedCandidatesListRef = useRef(false);
  const targetFetchAttemptedRef = useRef(null);

  useEffect(() => {
    if (!activeCandLoading) {
      hasLoadedCandidatesListRef.current = true;
    }
  }, [activeCandLoading]);

  const showInitialCandidatesLoading =
    activeCandLoading && !hasLoadedCandidatesListRef.current;
  useEffect(() => {
    // Wait for user to be available (with id or admin_id) before making API call
    if (user && Object.keys(user).length > 0 && (user?.id || user?.admin_id) && !isEffectRun.current) {
      const userId = user?.usertype === 13 ? user?.admin_id : user?.id;
      //console.log("userId", userId);
      if (userId) {
        isEffectRun.current = true; // Set to true after the first run
        //console.log("Dispatching getActiveCandidatesAction with userId:", userId);
        dispatch(getActiveCandidatesAction(userId, page, limit));
      }
    }
  }, [user, page, limit, dispatch]);

  // Set the first candidate as default selected and fetch their details
  useEffect(() => {
    if (!activeCandidates?.length) return;

    const urlParams = new URLSearchParams(window.location.search);
    const targetCandidateId =
      urlParams.get("candidate") ||
      location.state?.candidateId ||
      sessionStorage.getItem("target_candidate_id");

    if (targetCandidateId) {
      const foundIndex = activeCandidates.findIndex(
        (c) => String(c.candidate_id) === String(targetCandidateId)
      );

      if (foundIndex !== -1) {
        const selectedCand = activeCandidates[foundIndex];
        sessionStorage.removeItem("target_candidate_id");
        if (urlParams.has("candidate")) {
          urlParams.delete("candidate");
          const newUrl =
            window.location.pathname +
            (urlParams.toString() ? "?" + urlParams.toString() : "");
          window.history.replaceState({}, "", newUrl);
        }

        setActiveCandidateId(selectedCand.candidate_id);
        const targetPage = Math.floor(foundIndex / rowsPerPage) + 1;
        setCurrentPage(targetPage > 1 ? targetPage : 1);

        dispatch(resetAction());
        dispatch(selectedCandidateAction(selectedCand));
        dispatch(getCandidateDetailAction(selectedCand.candidate_id, user?.id));
        if (location.state?.candidateId) {
          navigate(location.pathname, {
            replace: true,
            state: { tabView: location.state?.tabView || "Submission" },
          });
        }
        return;
      }

      if (String(activeCandidateId) !== String(targetCandidateId)) {
        setActiveCandidateId(targetCandidateId);
        dispatch(resetAction());
        dispatch(
          selectedCandidateAction({ candidate_id: targetCandidateId })
        );
        dispatch(getCandidateDetailAction(targetCandidateId, user?.id));
      }
      return;
    }

    if (!activeCandidateId) {
      const selectedCand = activeCandidates[0];
      setActiveCandidateId(selectedCand.candidate_id);
      dispatch(resetAction());
      dispatch(selectedCandidateAction(selectedCand));
      dispatch(getCandidateDetailAction(selectedCand.candidate_id, user?.id));
    }
  }, [activeCandidates, activeCandidateId, dispatch, user?.id, rowsPerPage, location.state?.candidateId]);
  useEffect(() => {
    if (page === 1) {
      setCandidates(activeCandidates);
    } else {
      setCandidates((prev) => [...new Set([...prev, ...activeCandidates])]); // Prevent duplicates
    }
    if (
      activeCandidates.length < limit ||
      candidates.length >= total_candidates
    ) {
      setHasMore(false);
    }
  }, [activeCandidates]);

  const fetchMoreCandidates = useCallback(() => {
    if (activeCandidates?.length >= total_candidates) {
      setHasMore(false);
    } else {
      const pageNo = page + 1;
      setPage(pageNo);
      const userId = user?.usertype === 13 ? user?.admin_id : user?.id;
      dispatch(getActiveCandidatesAction(userId, pageNo, limit));
    }
  }, [activeCandidates]);

  const profileViews = [
    "Resume View",
    "Documents",
    "Profile View",
    "Resume Selection",
  ];

  const onClickCandidate = (candidate) => {
    const candidate_id = candidate.candidate_id;
    if (String(candidate_id) === String(activeCandidateId)) {
      if (profileViews.includes(tabView)) {
        openProfileView("");
      }
      return;
    }
    selectCandidate(candidate);
  };

  // Define ViewHandler to handle the view change
  const ViewHandler = (view) => {
    // Implement logic to handle different views if needed
    // console.log("Switching to view:", view);
  };
  const updateStatus = async () => {
    if (selectedCandidates.length === 0) {
      toast.error("No candidates selected");
      return;
    }

    setIsProcessing(true);

    try {
      const data = selectedCandidates.map((candidateId) => ({
        candidateid: candidateId,
        candidate_status: 0,
        inactive_reason: inactiveReason,
      }));

      await Promise.all(
        data.map((candidateData) =>
          dispatch(updateCandidateStatusAction(candidateData, user?.id))
        )
      );

      const remaining = candidates.filter(
        (candidate) => !selectedCandidates.includes(candidate.candidate_id)
      );

      if (remaining.length > 0) {
        const nextCandidate = remaining[0];
        setActiveCandidateId(nextCandidate.candidate_id);
        dispatch(resetAction());
        dispatch(selectedCandidateAction(nextCandidate));
        dispatch(getCandidateDetailAction(nextCandidate.candidate_id, user?.id));
      } else {
        setActiveCandidateId(null);
        dispatch(clearCandidateDetailsAction());
        dispatch(selectedCandidateAction(null));
      }

      toast.success("Selected candidates moved to inactive successfully");
      handleOpenSnackbar("Candidates Inactivated", "success");
      setSelectedCandidates([]);
      setCheckedCustomerData([]);
      setOpenDialog(false);
      setInactiveReason("");
      setShowInbox(false);
      setCurrentPage(1);
    } catch (error) {
      toast.error("Failed to move candidates to inactive");
    } finally {
      setIsProcessing(false);
    }
  };

  const handleCheckboxChange = (candidateId) => {
    const updatedSelectedCandidates = selectedCandidates.includes(candidateId)
      ? selectedCandidates.filter((id) => id !== candidateId)
      : [...selectedCandidates, candidateId];

    setSelectedCandidates(updatedSelectedCandidates);
    setShowInbox(updatedSelectedCandidates.length > 0);
  };

  const handleMouseEnter = useCallback(
    (id) => {
      if (hoveredCandidate !== id) {
        setHoveredCandidate(id);
      }
    },
    [hoveredCandidate]
  );

  // Filter candidates based on search query
  const filteredCandidates = candidates.filter((candidate) => {
    return (candidate.candidate_name?.toLowerCase() || "")
      .includes(searchQuery.toLowerCase());
  });

  const paginatedCandidates = filteredCandidates.slice(startIndex, endIndex)

  useEffect(() => {
    if (!onSearchEmptyChange) return;
    const isSearching = searchQuery.trim().length > 0;
    onSearchEmptyChange(isSearching && filteredCandidates.length === 0);
  }, [searchQuery, filteredCandidates.length, onSearchEmptyChange]);

  const selectCandidate = (candidate) => {
    if (!candidate?.candidate_id) return;
    setActiveCandidateId(candidate.candidate_id);
    dispatch(resetAction());
    dispatch(selectedCandidateAction(candidate));
    dispatch(getCandidateDetailAction(candidate.candidate_id, user?.id));
    openProfileView("");
  };

  useEffect(() => {
    setCurrentPage(1);

    if (!searchQuery.trim()) return;

    const firstMatch = filteredCandidates[0];
    if (!firstMatch) return;

    const matchId = String(firstMatch.candidate_id);
    if (
      matchId === String(activeCandidateId) &&
      matchId === String(candidateDetails?.candidate_id)
    ) {
      return;
    }

    selectCandidate(firstMatch);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchQuery]);

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
    const pageStart = (value - 1) * rowsPerPage;
    const firstOnPage = filteredCandidates[pageStart];
    if (firstOnPage) {
      selectCandidate(firstOnPage);
    }
  };

  const handleOpenSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };
  const handleDialogOpen = () => {
    setOpenDialog(true);
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
  };

  const handleDeleteClick = (e, candidate) => {
    // e.stopPropagation();
    setCandidateToDelete(candidate); // Set the candidate to delete
    setShowDeleteDialog(true);
  };

  const handleDeleteCandidate = async () => {
    if (selectedCandidates.length === 0) {
      toast.error("No candidates selected for deletion");
      return;
    }

    const deletedIds = [...selectedCandidates];
    const remaining = candidates.filter(
      (candidate) => !deletedIds.includes(candidate.candidate_id)
    );

    let nextCandidate = null;
    if (remaining.length > 0) {
      const focusId = activeCandidateId || deletedIds[0];
      const focusIndex = candidates.findIndex(
        (candidate) => String(candidate.candidate_id) === String(focusId)
      );

      if (focusIndex !== -1) {
        nextCandidate =
          candidates
            .slice(focusIndex + 1)
            .find((candidate) => !deletedIds.includes(candidate.candidate_id)) ||
          [...candidates]
            .slice(0, focusIndex)
            .reverse()
            .find((candidate) => !deletedIds.includes(candidate.candidate_id));
      }

      if (!nextCandidate) {
        nextCandidate = remaining[0];
      }
    }

    setIsDeleting(true);
    try {
      const response = await fetch(
        `${Key.domain}/candidate/delete_candidate`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            candidate_ids: deletedIds,
          }),
        }
      );

      if (response.ok) {
        toast.success(
          `${deletedIds.length} candidate(s) deleted successfully`
        );
        const userId = user?.usertype === 13 ? user?.admin_id : user?.id;
        await dispatch(getActiveCandidatesAction(userId, 1, limit));

        if (nextCandidate) {
          setActiveCandidateId(nextCandidate.candidate_id);
          dispatch(resetAction());
          dispatch(selectedCandidateAction(nextCandidate));
          dispatch(
            getCandidateDetailAction(nextCandidate.candidate_id, user?.id)
          );
        } else {
          setActiveCandidateId(null);
          dispatch(clearCandidateDetailsAction());
          dispatch(selectedCandidateAction(null));
        }

        setCurrentPage(1);
        setSelectedCandidates([]);
        setShowInbox(false);
        setShowDeleteDialog(false);
        setCandidateToDelete(null);
      } else {
        toast.error("Failed to delete candidate");
      }
    } catch (error) {
      toast.error("Error deleting candidate");
    } finally {
      setIsDeleting(false);
    }
  };

  useEffect(() => {
    if (!candidates || candidates.length === 0) {
      const hasTarget =
        new URLSearchParams(window.location.search).get("candidate") ||
        location.state?.candidateId ||
        sessionStorage.getItem("target_candidate_id");
      // Keep target selection while candidate list is still loading
      if (hasTarget) return;

      setActiveCandidateId(null);
      dispatch(clearCandidateDetailsAction());
      dispatch(selectedCandidateAction(null));
      return;
    }

    const urlParams = new URLSearchParams(window.location.search);
    const targetCandidateId =
      urlParams.get("candidate") ||
      location.state?.candidateId ||
      sessionStorage.getItem("target_candidate_id");

    // --- Priority 1: If there is a target candidate (e.g. just reactivated), always jump to it ---
    if (targetCandidateId) {
      const foundIndex = candidates.findIndex(
        (c) => String(c.candidate_id) === String(targetCandidateId)
      );

      if (foundIndex !== -1) {
        const target = candidates[foundIndex];

        // Clear the target so subsequent renders don't keep jumping
        sessionStorage.removeItem("target_candidate_id");
        if (urlParams.has("candidate")) {
          urlParams.delete("candidate");
          const newUrl = window.location.pathname + (urlParams.toString() ? '?' + urlParams.toString() : '');
          window.history.replaceState({}, '', newUrl);
        }

        targetFetchAttemptedRef.current = null;
        setActiveCandidateId(target.candidate_id);

        const targetPage = Math.floor(foundIndex / rowsPerPage) + 1;
        if (targetPage > 1) setCurrentPage(targetPage);
        else setCurrentPage(1);

        dispatch(resetAction());
        dispatch(selectedCandidateAction(target));
        dispatch(getCandidateDetailAction(target.candidate_id, user?.id));
        if (location.state?.candidateId) {
          navigate(location.pathname, {
            replace: true,
            state: { tabView: location.state?.tabView || "Submission" },
          });
        }
        return;
      }

      // Target not in list — refetch once only (repeating on every candidates update caused an infinite loop)
      if (targetFetchAttemptedRef.current !== String(targetCandidateId)) {
        targetFetchAttemptedRef.current = String(targetCandidateId);
        const userId = user?.usertype === 13 ? user?.admin_id : user?.id;
        if (userId) {
          dispatch(getActiveCandidatesAction(userId, 1, limit));
        }
        return;
      }

      // Already refetched once and still missing — clear target and continue with normal selection
      sessionStorage.removeItem("target_candidate_id");
      if (urlParams.has("candidate")) {
        urlParams.delete("candidate");
        const newUrl =
          window.location.pathname +
          (urlParams.toString() ? "?" + urlParams.toString() : "");
        window.history.replaceState({}, "", newUrl);
      }
      targetFetchAttemptedRef.current = null;
    }

    // --- Priority 2: Keep current selection if still present in the list ---
    const pendingTargetId =
      urlParams.get("candidate") ||
      location.state?.candidateId ||
      sessionStorage.getItem("target_candidate_id");

    if (pendingTargetId) {
      return;
    }

    const exists = candidates.some(
      (c) => String(c.candidate_id) === String(activeCandidateId)
    );

    if (!exists) {
      if (activeCandidateId) {
        return;
      }

      const selected = candidates[0];

      setActiveCandidateId(selected.candidate_id);
      setCurrentPage(1);

      dispatch(resetAction());
      dispatch(selectedCandidateAction(selected));
      dispatch(getCandidateDetailAction(selected.candidate_id, user?.id));
    }
  }, [candidates, location.state?.candidateId]);

  const handleDeleteDialogClose = () => {
    setShowDeleteDialog(false);
    setCandidateToDelete(null);

  };

  // Fetch recruiters if not present
  useEffect(() => {
    if (!myRecruiters || myRecruiters.length === 0) {
      // Try to get company_id or admin_id from user object
      const rec_data = {
        company_id: user?.companyid || user?.admin_id || user?.id,
      };

      //dispatch(getMyRecruitersAction(rec_data));
    }
  }, [dispatch, myRecruiters, user]);

  return (
    <div>
      <Grid>
        <Box>
          <Paper elevation={2} sx={paperStyles}>
            <Toolbar
              sx={{
                minHeight: "48px !important",
                bgcolor: "#fff",
                borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                {showSearchBox ? (
                  <TextField
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    placeholder="Search candidates..."
                    autoFocus
                    fullWidth
                  />
                ) : (
                  <Typography
                    sx={{
                      fontWeight: 500,
                      fontSize: isDesktopLarge
                        ? "18px"
                        : isDesktopMedium
                          ? "16px"
                          : isDesktopSmall
                            ? "14px"
                            : "13px",
                      margin: 0,
                    }}
                    paragraph
                    id="tableTitle"
                    component="div"
                  >
                    Active Candidates ({filteredCandidates.length})
                  </Typography>
                )}

                <div style={{ display: "flex", alignItems: "center" }}>
                  <Tooltip title="Search">
                    <SearchOutlined
                      style={{ color: "rgb(105, 105, 105)" }}
                      onClick={() => setShowSearchBox(!showSearchBox)} // Toggle search box visibility
                    />
                  </Tooltip>
                  {showSearchBox && (
                    <Tooltip title="Clear">
                      <ClearIcon
                        sx={hoverIconStyles}
                        onClick={() => {
                          setSearchQuery(""); // Clear the search query
                          setShowSearchBox(false); // Close the search box
                        }}
                      />
                    </Tooltip>
                  )}
                  {showInbox && (
                    <Tooltip title="Inactive">
                      <PersonOffOutlinedIcon
                        sx={hoverIconStyles}
                        onClick={handleDialogOpen}
                      />
                    </Tooltip>
                  )}
                  {showInbox && (
                    <Tooltip title="Delete Candidate">
                      <PersonRemoveIcon
                        sx={hoverIconStyles}
                        onClick={handleDeleteClick}
                      />
                    </Tooltip>
                  )}

                  <Dialog
                    open={openDialog}
                    onClose={handleDialogClose}
                    maxWidth="sm"
                    fullWidth
                  >
                    <DialogTitle>Move to Inactive</DialogTitle>
                    <DialogContent>
                      <Box sx={{ mt: 1 }}>
                        <TextField
                          fullWidth
                          multiline
                          rows={4}
                          placeholder="Enter reason for moving to inactive..."
                          value={inactiveReason}
                          onChange={(e) => setInactiveReason(e.target.value)}
                        />
                      </Box>
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={handleDialogClose}>Cancel</Button>
                      <Button
                        onClick={updateStatus}
                        variant="contained"
                        disabled={isProcessing}
                      >
                        {isProcessing ? "Processing..." : "Submit"}
                      </Button>
                    </DialogActions>
                  </Dialog>
                  <Dialog
                    open={showDeleteDialog}
                    onClose={handleDeleteDialogClose}
                    aria-labelledby="delete-dialog-title"
                    maxWidth="sm"
                    fullWidth
                  >
                    <DialogTitle id="delete-dialog-title" sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1,
                      //color: '#d32f2f',
                      fontWeight: 600,
                      fontSize: '1.25rem',
                      padding: '16px 24px'
                    }}>
                      <DeleteIcon color="error" />
                      Delete Candidate
                    </DialogTitle>
                    <Divider />
                    <DialogContent
                      style={{
                        borderRadius: "5px",
                        padding: "5px",
                        margin: "0px 10px 10px 10px",
                      }}
                    >
                      <Typography style={{
                        margin: "0px 10px 10px 10px",
                      }}>
                        Are you sure you want to delete {candidateToDelete?.candidate_name || (selectedCandidates.length > 1 ? `${selectedCandidates.length} selected candidates` : 'this candidate')}?
                      </Typography>
                      <Alert severity="warning" sx={{
                        backgroundColor: '#fff3e0',
                        '& .MuiAlert-icon': {
                          color: '#ed6c02'
                        }
                      }}>
                        You're about to permanently delete key data related to candidates in your system, including:<br />
                        ✅ Login credentials<br />
                        ✅ Uploaded resumes and documents<br />
                        ✅ Interview schedules<br />
                        ✅ Job interests<br />
                        ✅ Submissions to jobs<br />
                        ✅ Allocations or assignments<br />
                        <strong>Instead, consider making the candidate inactive to preserve their data.</strong>
                      </Alert>
                    </DialogContent>
                    <Divider />
                    <DialogActions>
                      <Button onClick={handleDeleteDialogClose} variant="outlined">
                        no
                      </Button>
                      <Button
                        variant="contained"
                        color="error"
                        onClick={handleDeleteCandidate} // Call delete handler
                        disabled={isDeleting}
                      >
                        {isDeleting ? "Deleting..." : "Yes"}
                      </Button>
                    </DialogActions>
                  </Dialog>
                </div>
              </Box>
            </Toolbar>
            <Divider sx={{ width: "100%" }} />

            {/* <InfiniteScroll
              dataLength={total_candidates || 0}
              next={fetchMoreCandidates}
              hasMore={hasMore}
              // endMessage={<Typography>No Candidates Found</Typography>}

              style={{ height: window.innerHeight - 50, overflow: "scroll" }}
              scrollableTarget="scrollableDiv"
              pullDownToRefreshThreshold={50}
            > */}

            {/* {activeCandidates.length} */}
            {showInitialCandidatesLoading ? (
              <Box sx={{ flex: 1, overflowY: "auto", p: 1 }}>
                {Array.from({ length: 8 }).map((_, i) => (
                  <LoadingSkeleton key={i} />
                ))}
              </Box>
            ) : (
              <>
                <List id="scrollable" sx={{ flex: 1, overflowY: "auto", p: 0 }}>
                  {paginatedCandidates.length > 0 &&
                    paginatedCandidates.map((candidate, index) => (
                      <ListItemButton
                        key={index}
                        selected={candidate?.candidate_id === activeCandidateId} // Highlight selected candidate
                        onClick={() => onClickCandidate(candidate)}
                        onMouseEnter={() =>
                          handleMouseEnter(candidate.candidate_id)
                        }
                        onMouseLeave={() => handleMouseEnter(null)}
                        sx={{
                          //borderLeft: `2px solid ${candidate.r_id ? 'transparent' : 'blue'}`,
                          backgroundColor:
                            candidate?.candidate_id === activeCandidateId
                              ? "#e0e0e0"
                              : selectedCandidates.includes(candidate?.candidate_id)
                                ? "#c5cae9" // Background color for selected checkbox
                                : "transparent", // Transparent for inactive
                          "&.Mui-selected": {
                            backgroundColor: "#c5cae9 !important", // override MUI default
                          },
                          "&.Mui-selected:hover": {
                            backgroundColor: "#e0e0e0 !important", // optional: different on hover
                          },
                        }}
                      >
                        <div style={{ display: "flex", gap: 10, width: "100%", }}>
                          {hoveredCandidate === candidate.candidate_id ||
                            selectedCandidates.includes(candidate.candidate_id) ? (
                            <Checkbox
                              checked={selectedCandidates.includes(
                                candidate.candidate_id
                              )}
                              onChange={() =>
                                handleCheckboxChange(candidate.candidate_id)
                              }
                            />
                          ) : (
                            <Avatar
                              alt={candidate?.candidate_name?.[0] || "N"} // Fallback to "N" if candidate name is missing
                              src={
                                candidate?.image
                                  ? `${Key.aws_bucket_profile}/attachments/user_${candidate?.user_id}/profileimages/${candidate?.image}`
                                  : null // If no image, src will be null
                              }
                              style={{
                                textTransform: "capitalize",
                                fontSize: "14px",
                                cursor: "pointer",
                                width: 40,
                                height: 40,

                                backgroundColor: candidate?.image
                                  ? "transparent"
                                  : avatarColors[index % avatarColors.length], // Dynamic color if no image
                                color: "#000", // Text color for the fallback
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              {/* Render the first letter of the candidate's name if no image */}
                              {!candidate?.image &&
                                candidate?.candidate_name?.[0]?.toUpperCase()}
                            </Avatar>
                          )}
                          <Stack direction="column">
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                            >
                              <Typography
                                sx={{
                                  fontSize: isDesktopXS ? "10px" : "12px",
                                  fontWeight: 600,
                                  margin: 0,
                                  width: isDesktopLarge
                                    ? "200px"
                                    : isDesktopMedium
                                      ? "150px"
                                      : isDesktopSmall
                                        ? "100px"
                                        : "80px",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                {candidate.candidate_name}
                              </Typography>

                              {hoveredCandidate === candidate.candidate_id && (
                                <Box sx={{ display: "flex" }}>
                                  <Tooltip followCursor title="Resume Files">
                                    <DescriptionOutlined
                                      sx={hoverIconStyles}
                                      onClick={(e) => {
                                        // dispatch(
                                        //   selectedCandidateAction(candidate)
                                        // );
                                        // dispatch(
                                        //   getCandidateDetailAction(
                                        //     candidate?.candidate_id,
                                        //     user?.id
                                        //   )
                                        // );
                                        e.stopPropagation();
                                        openProfileView("Resume View");
                                      }}
                                    />
                                  </Tooltip>
                                  <Tooltip followCursor title="Documents">
                                    <DifferenceOutlined
                                      sx={hoverIconStyles}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        openProfileView("Documents");
                                        dispatch(
                                          selectedCandidateAction(
                                            candidate.candidate_id
                                          )
                                        );
                                      }}
                                    />
                                  </Tooltip>
                                  {candidate.r_id && user?.usertype == 7 ? (
                                    <Tooltip
                                      followCursor
                                      title={`Allocated to: ${getRecruiterName(candidate.r_id)}`}
                                    // onClick={(e) => {

                                    //   e.stopPropagation();
                                    //   openProfileView("Documents"); 
                                    //   dispatch(
                                    //     selectedCandidateAction(
                                    //       candidate.candidate_id
                                    //     )
                                    //   );
                                    // }}
                                    >
                                      <HowToRegIcon
                                        sx={hoverIconStyles}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          // Optionally, add any logic you want here for recruiter allocation icon click
                                        }}
                                      />
                                    </Tooltip>
                                  ) : null}
                                  {/* <Tooltip followCursor title="Profile View">
                                <PersonOutlineRounded
                                  onClick={(e) => {
                                    // dispatch(
                                    //   selectedCandidateAction(candidate)
                                    // );
                                    // dispatch(
                                    //   getCandidateDetailAction(
                                    //     candidate?.candidate_id,
                                    //     user?.id
                                    //   )
                                    // );
                                    e.stopPropagation();
                                    openProfileView("Profile View");
                                  }}
                                  sx={hoverIconStyles}
                                />
                              </Tooltip> */}
                                </Box>
                              )}
                            </Box>
                            <Box>
                              <Typography
                                sx={{
                                  fontSize: isDesktopXS ? "9px" : "11px",
                                  margin: 0,
                                }}
                              >
                                {candidate.role}
                              </Typography>
                            </Box>
                          </Stack>
                        </div>
                      </ListItemButton>
                    ))}
                </List>
                {filteredCandidates.length > 10 && (
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      p: 1,
                      borderTop: "1px solid rgba(0, 0, 0, 0.12)",
                      bgcolor: "#fff",
                    }}
                  >
                    <Pagination
                      count={Math.ceil(filteredCandidates.length / rowsPerPage) || 1}
                      page={currentPage}
                      onChange={handlePageChange}
                      color="primary"
                      size="small"
                      sx={{ display: 'flex', justifyContent: 'center', mb: 1 }}
                      siblingCount={0}
                      boundaryCount={1}
                    />

                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', px: 2 }}>
                      <Typography variant="body2" sx={{ mr: 1 }}>Rows per page:</Typography>
                      <Select
                        size="small"
                        variant="standard"
                        value={rowsPerPage}
                        onChange={(e) => {
                          setRowsPerPage(parseInt(e.target.value, 10));
                          setCurrentPage(1);
                          if (filteredCandidates[0]) {
                            selectCandidate(filteredCandidates[0]);
                          }
                        }}
                        sx={{ width: 60 }}
                      >
                        <MenuItem value={10}>10</MenuItem>
                        <MenuItem value={25}>25</MenuItem>
                        <MenuItem value={50}>50</MenuItem>
                        <MenuItem value={100}>100</MenuItem>
                      </Select>
                    </Box>
                  </Box>
                )}
              </>
            )}
          </Paper>
        </Box>
      </Grid>
    </div>
  );
};

export default ActiveCandidates;
